import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import App from "./App";
import "./index.css";

const nativeFetch = window.fetch.bind(window);
window.fetch = (input, init = {}) => nativeFetch(input, { credentials: "include", ...init });

function getBasename() {
    const raw = process.env.PUBLIC_URL;
    if (!raw) return "/";
    try {
        const u = new URL(raw, window.location.origin);
        const path = u.pathname.replace(/\/+$/, "");
        return path || "/";
    } catch {
        return "/";
    }
}

const container = document.getElementById("root");
if (!container) {
    throw new Error('Root element "#root" not found');
}

// --- ✅ Prevent login background flash on refresh ---
document.body.classList.remove("login-page");
document.body.style.background = "linear-gradient(90deg, #d4af37 0%, #000 65%)";
document.body.style.backgroundAttachment = "fixed";
document.body.style.backgroundRepeat = "no-repeat";
document.body.style.backgroundSize = "cover";

const root = createRoot(container);

root.render(
    <React.StrictMode>
        <BrowserRouter basename={getBasename()}>
            <App />
        </BrowserRouter>
    </React.StrictMode>
);
